
import Vue from 'vue';

export default Vue.extend({
	props: {
		crumbs: Array as () => Array<{
			label: string,
			title?: string,
			onClick?: () => void
		}>,
		disabled: Boolean,
	},
	computed: {

	}
})
